
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface CoachPrivacySettingsSectionProps {
  showProfilePublic: boolean;
  showContactPublic: boolean;
  onPrivacyChange: (setting: string, value: boolean) => void;
}

export const CoachPrivacySettingsSection: React.FC<CoachPrivacySettingsSectionProps> = ({
  showProfilePublic,
  showContactPublic,
  onPrivacyChange
}) => {
  return (
    <Card className="bg-gray-700 border-gray-600">
      <CardHeader>
        <CardTitle className="text-white text-lg">Privacy Settings</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between p-4 bg-gray-600 rounded-lg">
          <div>
            <Label className="text-white font-medium">Make Coach Profile Public</Label>
            <p className="text-sm text-gray-400">Allow teams and players to discover your profile</p>
          </div>
          <Switch
            checked={showProfilePublic}
            onCheckedChange={(checked) => onPrivacyChange('show_profile_public', checked)}
          />
        </div>
        
        <div className="flex items-center justify-between p-4 bg-gray-600 rounded-lg">
          <div>
            <Label className="text-white font-medium">Show Contact Information</Label>
            <p className="text-sm text-gray-400">Display your contact info publicly</p>
          </div>
          <Switch
            checked={showContactPublic}
            onCheckedChange={(checked) => onPrivacyChange('show_contact_public', checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
};
